var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "upload-cutter"
  }, [_c('ImgCutter', {
    attrs: {
      "modal-title": $t("bge8ia4", "图片裁剪"),
      "label": $t("ikxafd4", "选择图片"),
      "boxWidth": 360,
      "boxHeight": 180,
      "cutWidth": 360,
      "cutHeight": 180,
      "tool": false,
      "fileType": "png,jpg,jpeg"
    },
    on: {
      "cutDown": _vm.cutDown
    },
    scopedSlots: _vm._u([{
      key: "open",
      fn: function () {
        return [_c('span', [_c('span', {
          staticClass: "content",
          on: {
            "mouseenter": _vm.mouseEnter,
            "mouseleave": _vm.mouseLeave
          }
        }, [_c('img', {
          staticClass: "img",
          attrs: {
            "src": _vm.file.url || _vm.InitImg
          }
        }), _c('Button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: _vm.select,
            expression: "select"
          }],
          staticClass: "select_img"
        }, [_vm._v($t("ikxafd4", "选择图片"))])], 1)])];
      },
      proxy: true
    }, {
      key: "confirm",
      fn: function () {
        return [_c('span', [_c('Button', [_vm._v($t("kzjg2", "确定"))])], 1)];
      },
      proxy: true
    }])
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };